module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("grzV6"))).then(() => parcelRequire('ljYL6'));